import React from 'react';

import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';

import './SearchHeader.scss';

const SearchHeader = ({
    searchTerm,
    placeholder = 'Search...',
    addButtonText = 'Add New Item',
    creating,
    hasManagingAccess,
    onSearchChange,
    onAddNew,
}) => (
    <Row className="mb-4">
        <Col md={4}>
            <InputGroup className="search-input-group">
                <Form.Control
                    type="text"
                    placeholder={placeholder}
                    value={searchTerm}
                    className="search-input"
                    onChange={onSearchChange}
                />
                <button
                    className="search-btn"
                    type="button"
                    title="Search"
                />
            </InputGroup>
        </Col>
        <Col md={8}>
            {hasManagingAccess && onAddNew && (
                <Button
                    variant="primary"
                    disabled={creating}
                    className="new-item-btn float-end px-4"
                    onClick={onAddNew}
                >
                    {creating ? 'Adding...' : addButtonText}
                </Button>
            )}
        </Col>
    </Row>
);

SearchHeader.propTypes = {
    searchTerm: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    addButtonText: PropTypes.string,
    creating: PropTypes.bool,
    hasManagingAccess: PropTypes.bool.isRequired,
    onSearchChange: PropTypes.func.isRequired,
    onAddNew: PropTypes.func,
};

export default SearchHeader;

